export enum ShippingPriceType {
  FLAT = 'flat',
  DYNAMIC = 'dynamic',
}
